// extracted by mini-css-extract-plugin
export default {"approvedPrimaryButton":"approvedPrimaryButton_approvedPrimaryButton__7vW-5"};